module.exports = __webpack_public_path__ + "img/layout-2.5afd4b42.jpg";